import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { productsData } from "../components/productsData";
import { CartContext } from "../CartContext";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { motion, useAnimation, useInView } from "framer-motion";

const CartCheckout = () => {
  const cart = useContext(CartContext);
  const totalPrice = cart.getTotalCost(); // Get the total price here
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState("Kosovë");
  const [shippingPrice, setShippingPrice] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.title = "Checkout | 21 Dite Produkt";
  }, []);
  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0,
  );
  const subtotal = cart.items.reduce(
    (sum, product) => sum + product.finalPrice,
    0,
  );

  const sendEmail = (e) => {
    e.preventDefault();
    const form = e.target;

    // Validate form fields before submission
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(e.target);

    // Extract product details from the cart items
    const productDetails = cart.items.map((product) => ({
      brand: product.brand,
      productTitle: product.name,
      price: (product.quantity * product.finalPrice).toFixed(2),
      quantity: product.quantity,
    }));

    // Construct the email body as plain text
    const emailBody = `
      Name: ${formData.get("name")}
      Email: ${formData.get("email")}
      Phone: ${formData.get("phone")}
      Address: ${formData.get("street")}, ${formData.get(
        "city",
      )}, ${formData.get("country")}, ${formData.get("postalCode")}
      Message: ${formData.get("message")}
      Product Details:
      ${productDetails
        .map(
          (product) =>
            `${product.productTitle} - Quantity: ${
              product.quantity
            } - Price: €${(product.quantity * product.finalPrice).toFixed(2)}`,
        )
        .join("\n")}
      Total Price: €${subtotal.toFixed(2)}
    `;

    // If the form is valid, send the email using emailjs
    if (form.checkValidity()) {
      emailjs
        .sendForm(
          "service_80aig4u", // Replace with your service ID
          "template_2osbvog", // Replace with your template ID
          e.target, // The form reference
          "u_41kRZzICRMIjAy6", // Replace with your user ID
        )
        .then((response) => {
          toast.success("Form submitted successfully!");
          navigate("/thank-you-page");
        })
        .catch((error) => {
          toast.error("Failed to send the email. Please try again.");
          console.error("EmailJS Error: ", error);
        });
    } else {
      console.log("Please fill in all fields.");
    }
  };
  const handleShippingChange = (e) => {
    const selectedOption = e.target.value;
    setSelectedCountry(selectedOption);

    // Set shipping prices based on country
    if (selectedOption === "Kosovë") {
      setShippingPrice(0);
    } else if (selectedOption === "Shqipëri" || selectedOption === "Maçedoni") {
      setShippingPrice(3);
    } else {
      setShippingPrice(0); // Default to 0 if no specific rule applies
    }
  };

  const productDetailsText =
    cart.items
      .map((product) => {
        return `- ${product.name} - Quantity: ${product.quantity} - Price: €${(
          product.quantity * product.finalPrice
        ).toFixed(2)} / `;
      })
      .join("\n") + `\n- Total: €${totalPrice.toFixed(2)}`;

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);

  useEffect(() => {
    console.log("Cart Items in Checkout Page:", cart.items);
  }, [cart.items]);

  const [forceRender, setForceRender] = useState(false);

  useEffect(() => {
    setForceRender((prev) => !prev); // Trigger a re-render when the cart updates
  }, [cart.items]);

  return (
    <Container>
      <ToastContainer />
      <>
        <motion.div
          ref={ref}
          className="left"
          variants={{
            hidden: { opacity: 0, x: -300 },
            visible: { opacity: 1, x: 0 },
          }}
          initial="hidden"
          animate={animation}
          transition={{ duration: 0.4, delay: 0.3, type: "spring" }}
        >
          {cart.items.map((product) => (
            <div className="item" key={product.id}>
              <img src={product.image} alt="" />
              <span>
                <h4>{product.brand}</h4>
                <h3>{product.name}</h3>
                <h4>{/* Sasia: <span>{product.quantity}</span> */}</h4>
                <h2>
                  €{(product.quantity * product.finalPrice).toFixed(2)}
                </h2>{" "}
                {/* Use finalPrice */}
              </span>
            </div>
          ))}

          <div className="total">
            <span>
              <h3>Subtotal</h3>
              <h2>€{totalPrice.toFixed(2)}</h2>
            </span>
            <span>
              <h3>Transporti</h3>
              <h2>
                {shippingPrice === 0 ? (
                  <h2>FALAS</h2>
                ) : (
                  <h2>€{shippingPrice.toFixed(2)}</h2>
                )}
              </h2>
            </span>
            <hr />
            <span>
              <h2>Totali</h2>
              <h1>€{(totalPrice + shippingPrice).toFixed(2)}</h1>{" "}
              {/* Updated total calculation */}
            </span>
          </div>
        </motion.div>
        <hr />
        <motion.form
          className="right"
          onSubmit={sendEmail}
          variants={{
            hidden: { opacity: 0, x: 300 },
            visible: { opacity: 1, x: 0 },
          }}
          initial="hidden"
          animate={animation}
          transition={{ duration: 0.4, delay: 0.3, type: "spring" }}
        >
          <p>Per porosi ju lutem lini te gjitha te dhenat e sakta</p>
          <input
            type="hidden"
            name="productDetails"
            value={productDetailsText}
          />
          <div className="contact">
            <label>Detajet e Porosisë*</label>

            <div className="delivery">
              {/* <label>Dergesa</label> */}
              <span>
                <input
                  name="name"
                  type="text"
                  placeholder="Emri dhe Mbiemri"
                  required
                />
                <input
                  type="phone"
                  name="phoneNumber"
                  placeholder="Numri Kontaktues"
                  required
                />
              </span>
              <span>
                <select onChange={handleShippingChange} name="country" required>
                  <option value="Kosovo">Kosovë</option>
                  <option value="Shqipëri">Shqipëri</option>
                  <option value="Maçedoni">Maçedoni</option>
                </select>
                <input name="city" type="text" placeholder="Qyteti" required />
              </span>
              <input name="address" type="text" placeholder="Adresa" required />
              <textarea
                name="message"
                cols="10"
                rows="4"
                placeholder="Mesazh (Opsionale)"
              ></textarea>
            </div>
          </div>

          <button type="submit">PERFUNDO POROSINE</button>
        </motion.form>
      </>
    </Container>
  );
};
const Container = styled.div`
  padding: 4em 7%;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 7%;
  margin: auto;
  max-width: 1500px;
  hr {
    height: 70vh;
    border: 1px solid #dfdfdf;
  }
  .left {
    display: flex;
    flex-direction: column;
    align-items: end;
    flex: 3;
    .item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px;
      align-self: flex-start;
      border-bottom: 1px solid #e4e0db;
      width: 100%;
      img {
        height: 120px;
        width: auto;
        border-radius: 0px;
        object-fit: contain;
        background-color: white;
      }
      span {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        h4 {
          text-transform: capitalize;
          font-size: 17px;
          font-weight: 300;
          color: gray;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 7px;
          span {
            color: #353432;
            font-weight: 500;
          }
        }
        h3 {
          font-weight: 500;
          color: #575250;
        }
        h2 {
          margin-top: 10px;
          font-weight: 500;
          color: #8d7f7a;
        }
      }
    }
    .total {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      margin-top: 3em;
      hr {
        border: none;
        height: 1px;
        border-bottom: 1px solid #dad3d0;
      }
      span {
        display: flex;
        justify-content: space-between;
        h3 {
          font-weight: 400;
          color: #8d7f7a;
        }
        h2 {
          font-weight: 500;
          font-size: 19px;
          color: #9b8983;
        }
        h1 {
          font-size: 20px;
          font-weight: 600;
          color: #575250;
        }
      }
    }
  }
  .right {
    flex: 4;
    display: flex;
    flex-direction: column;
    gap: 2em;
    margin-top: 1em;
    div {
      display: flex;
      flex-direction: column;
      gap: 7px;
    }
    span {
      font-weight: 400;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    input,
    textarea,
    select {
      font-family: "Montserrat", sans-serif;
      outline: none;
      border: 1px solid #dfdfdf;
      font-size: 17px;
      border-radius: 7px;
      padding: 14px;
      background: none;
      color: gray;
      width: 100%;
    }
    label {
      font-weight: 500;
      font-size: 20px;
    }
    label {
      font-weight: 500;
      font-size: 20px;
    }
    .shipping {
      background-color: var(--secondaryBackgroundColor);
      padding: 20px 30px;
      border-radius: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      span {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        h3 {
          font-size: 20px;
          font-weight: 500;
        }
        h4 {
          font-weight: 300;
        }
      }
    }
    button {
      margin: auto;
      font-family: "Poppins", sans-serif;
      font-size: 18px;
      background: #085a05;
      color: white;
      border: none;
      margin-top: 0;
      border-radius: 7px;
      padding: 10px 14px;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        box-shadow: 0 0 10px 2px #91827e;
      }
    }
  }
  @media (max-width: 700px) {
    flex-direction: column;
    gap: 2em;
    hr {
      height: 1px;
    }
    .left {
      .total {
      }
    }
  }
`;

export default CartCheckout;
